export const ROUTES = [
    {
        name: 'Technology',
        path: '/#technologies',
        hasChild: false,
        anchor: 'technologies'
    },
    {
        name: 'Use Cases',
        hasChild: true,
        items: [
            {
                name: 'Beauty – Skincare',
                path: '/use-cases/beauty-skincare'
            },
            {
                name: 'Beauty – Color Cosmetics',
                path: '/use-cases/beauty-colorcosmetics'
            },
            {
                name: 'Beauty – Hair',
                path: '/use-cases/beauty-hair'
            },
            {
                name: 'Food – Superfoods',
                path: '/use-cases/food-superfoods'
            },
            {
                name: 'Food – Supplements ',
                path: '/use-cases/food-supplements'
            }
        ]
    },
    {
        name: 'Team',
        path: '/team',
        hasChild: false
    }
]
